<template>
  <div id="app">
    <div class="content" v-if="signedIn && !checkingAuth">
      <DataPointManager :loading="loading" :dataPoints="dataPoints" @itemAdded="getCodenames" @itemDeleted="getCodenames"/>
      <div class="sign-out-button"><amplify-sign-out></amplify-sign-out></div>
    </div>
    <a-spin v-if="checkingAuth" />
    <div class="sign-in" v-if="!signedIn && !checkingAuth">
      <h1 class="signed-out-title">Nourish Data Point Manager</h1>
      <amplify-authenticator>
        <amplify-sign-in slot="sign-in" hide-sign-up="true"></amplify-sign-in>
      </amplify-authenticator>
    </div>
  </div>
</template>

<script>
import DataPointManager from '@/components/DataPointManager'

import { onAuthUIStateChange } from '@aws-amplify/ui-components'
import { Auth, API } from 'aws-amplify'

export default {
  name: 'App',
  components: {
    DataPointManager
  },
  data: () => ({
    loading: true,
    signedIn: false,
    dataPoints: [],
    checkingAuth: true
  }),
  async beforeCreate() {
    this.signedIn = false
    const user = await Auth.currentUserInfo()
    if (user) {
      this.getCodenames()
      this.signedIn = true
    } else {
      this.signedIn = false
    }
    this.checkingAuth = false
    onAuthUIStateChange((authState) => {
      this.signedIn = authState === 'signedin' ? true : false;
      if (this.signedIn) {
        this.getCodenames()
      }
    })
  },
  methods: {
    async getCodenames() {
      const response = await API.get('dataPointManagerAPI', '/codenames/')
      if (response.data) {
        this.dataPoints = response.data
        window.setTimeout(() => this.loading = false, 1000)
      }
      return response.error
    }
  }
}
</script>

<style>
#app {
  margin-top: 60px;
  display: flex;
  justify-content: center;
}

.content {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.sign-in {
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.signed-out-title {
  font-size: 40px;
}

.sign-out-button {
  width: 200px;
  margin: 30px;
}
</style>
